import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TILL_STATE_FEATURE_KEY,
  TillStatusPartialState,
  TillStatusState,
} from './till-status.reducer';
import * as fromTillStatus from './till-status.reducer';

export const getTillStatusState = createFeatureSelector<
  TillStatusPartialState,
  TillStatusState
>(TILL_STATE_FEATURE_KEY);

export const getTillStatus = createSelector(
  getTillStatusState,
  (state: fromTillStatus.TillStatusState) => ({
    status: state.status,
    previousStatusValue: state.previousStatusValue,
  })
);

export const getTillStatusLoading = createSelector(
  getTillStatusState,
  (state: fromTillStatus.TillStatusState) => state.loading
);

export const getIsUpdatingTillStatus = createSelector(
  getTillStatusState,
  (state: fromTillStatus.TillStatusState) => state.isUpdatingState
);
